import React from "react";

function Switch(props) {
  return (
    <div
      style={{
        display: "flex",
        overflow: "hidden",
        borderRadius: 10,
        border: "1px solid #ccc",
      }}
    >
      <div
        onClick={() => props.onChanged(0)}
        style={{
          cursor: "pointer",
          fontSize: 12,
          fontWeight: 600,
          flex: 1,
          padding: "10px 5px",
          textAlign: "center",
          backgroundColor: props.active === 0 ? "#555" : "unset",
          color: props.active === 0 ? "#fff" : "unset",
          ...props.style,
        }}
      >
        <i
          aria-hidden
          style={{
            marginRight: 5,
            visibility: props.active === 0 ? "visible" : "hidden ",
          }}
          className="fas fa-check"
        />

        {props.values[0]}
      </div>
      <div
        onClick={() => props.onChanged(1)}
        style={{
          cursor: "pointer",
          fontSize: 12,
          fontWeight: 600,
          flex: 1,
          padding: "10px 5px",
          textAlign: "center",
          backgroundColor: props.active === 1 ? "#555" : "unset",
          color: props.active === 1 ? "#fff" : "unset",
          ...props.style,
        }}
      >
        <i
          aria-hidden
          style={{
            marginRight: 5,
            visibility: props.active === 1 ? "visible" : "hidden ",
          }}
          className="fas fa-check"
        />

        {props.values[1]}
      </div>
    </div>
  );
}

export default Switch;
